import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoginBtnsasyncReqPros, LoginBtnsInitialState } from "../model/LoginBtnsReducerType";

const reducerId = "LoginBtnsReducer/asyncReqIsLogin";
const controllerMap = new Map();

const initialState: LoginBtnsInitialState = {
    asyncIsLogin: {
        status: "",
        isLogin: false,
        MEM_UDID: "",
        NICKNAME: ""
    },
    isShowLodingBar: true,
    isShowLoginPop: false
};

const slice = createSlice({
    name: "LoginBtnsReducer",
    initialState,
    reducers: {
        setIsShowLoginPop: (state, action) => {
            state.isShowLoginPop = action.payload;
        },
        setIsShowLodingBar: (state, action) => {
            state.isShowLodingBar = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqIsLogin.pending, (state) => {
            state.asyncIsLogin.status = "LOADING";
        });
        builder.addCase(asyncReqIsLogin.fulfilled, (state, action) => {

            state.asyncIsLogin.status = "COMPLETE";
            state.asyncIsLogin.isLogin = action.payload.isLogin;
            state.asyncIsLogin.MEM_UDID = action.payload.MEM_UDID;
            state.asyncIsLogin.NICKNAME = action.payload.NICKNAME;
        })
        builder.addCase(asyncReqIsLogin.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.asyncIsLogin.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqIsLogin = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        LoginBtnsasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ logout_req_yn }: LoginBtnsasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/IsLogin.aspx?logout_req_yn=${encodeURIComponent(logout_req_yn)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const LoginBtnsActions = slice.actions;
export default slice.reducer;